import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Operations = ({ match }) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect
          exact
          from={`${match.url}/`}
          to={`${match.url}/requestpointintimerestore`}
        />

        <Route
          path={`${match.url}/requestpointintimerestore`}
          component={asyncComponent(() =>
            import("./routes/RequestPointInTimeRestore/")
          )}
        />

        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default Operations;
